import { useCmsHashState } from './useHashState';

export type ExclusiveRewardsModalState = {
  exclusiveRewardsProductUid: string;
};

const useExclusiveRewardsModal = () => {
  const [queryParams, setQueryParams] =
    useCmsHashState<ExclusiveRewardsModalState>({
      exclusiveRewardsProductUid: 'string',
    });

  const productUid = queryParams.exclusiveRewardsProductUid ?? '';
  const isOpen = Boolean(productUid);

  const openModal = (exclusiveRewardsProductUid: string) => {
    setQueryParams({
      exclusiveRewardsProductUid,
    });
    return true;
  };

  const closeModal = () => {
    setQueryParams({
      exclusiveRewardsProductUid: undefined,
    });
    return false;
  };

  return {
    openModal,
    closeModal,
    isOpen,
    productUid,
  };
};

export default useExclusiveRewardsModal;
